"use client";

import { useCollection } from "@/hooks/use-collection";
import { Track } from "@/lib/generated/graphql";
import { cn } from "@/lib/utils";
import { useI18n } from "@/locales/client";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/navigation";
type TrackCardProps = {
  tracks: Track[];
};
const TrackCard = ({ tracks }: TrackCardProps) => {
  const { gridToggle } = useCollection();
  const router = useRouter();
  const handleRedirect = (type: string, slug: string) => {
    router.push(`/collection/${type}/${slug}`);
  };
  const t = useI18n();
  return (
    <div className="space-y-8">
      <div
        className={cn(
          gridToggle?.viewMode === "grid"
            ? "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
            : "flex flex-col space-y-4"
        )}
      >
        {tracks?.map((track) => (
          <div
            key={track?.id}
            className={cn(
              "bg-card border border-border rounded-xl p-4 shadow-sm hover:shadow-md transition cursor-pointer group",
              gridToggle?.viewMode === "grid"
                ? "flex flex-col items-start"
                : "flex flex-col md:flex-row gap-4"
            )}
            onClick={() => {
              if (track?.type && track?.slug) {
                handleRedirect(track.type, track.slug);
              }
            }}
          >
            <Image
              src={track?.image?.url || "/placeholder.jpg"}
              alt={track?.title}
              width={120}
              height={120}
              quality={100}
              priority
              loader={({ src }) => src}
              className={cn(
                "rounded-lg object-cover transition",
                gridToggle?.viewMode === "grid" ? "w-full h-60" : "w-32 h-32"
              )}
            />

            <div className="flex flex-col justify-between flex-1">
              <div className="mt-3 md:mt-0">
                <h3 className="font-semibold text-foreground line-clamp-1">
                  {track?.title}
                </h3>
                <p className="text-sm text-muted-foreground line-clamp-1">
                  {track?.artist}
                </p>
                <p className="text-xs text-muted-foreground mt-1">
                  {track?.releaseDate}
                </p>
              </div>
              <Link
                href={`/collection/${track?.type}/${track?.slug}`}
                onClick={(e) => e.stopPropagation()}
                className="mt-3 text-sm text-primary hover:underline"
              >
                {t("getMore")}
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
TrackCard.displayName = "TrackCard";
export { TrackCard };
